<nav
  class="space-y-1 overflow-hidden rounded-lg border border-gray-300 bg-white"
  aria-label="Navigation"
>
  @for (link of links(); track $index) {
    <a
      [routerLink]="link.to"
      [queryParams]="link.queryParams"
      [queryParamsHandling]="link.queryParamsHandling"
      routerLinkActive
      [routerLinkActiveOptions]="link.routerLinkActiveOptions || { exact: false }"
      #rla="routerLinkActive"
      class="group flex items-center border-s-4 px-3 py-2 text-sm/6 font-semibold"
      [class]="rla.isActive ? klass().active : klass().inactive"
      [attr.aria-current]="rla.isActive"
    >
      {{ link.label | translate }}
    </a>
  }
</nav>
